module.exports = __webpack_public_path__ + "img/popularize09.611f22c0.png";